export const teamData = [
  {
    id: 1,
    name: "Team Member",
    position: "Creative Director",
    bio: "Team Member",
    image: "/assets/images/team/memberPlaceholder.png",
    social: {
      linkedin: "#",
      twitter: "#",
    },
  },
  {
    id: 2,
    name: "Team Member",
    position: "Team Member",
    bio: "Team Member",
    image: "/assets/images/team/memberPlaceholder.png",
    social: {
      linkedin: "#",
      twitter: "#",
    },
  },
  {
    id: 3,
    name: "Team Member",
    position: "Team Member",
    bio: "Team Member",
    image: "/assets/images/team/memberPlaceholder.png",
    social: {
      linkedin: "#",
      twitter: "#",
    },
  },
];
